<template>
  <div
    class="grid-debugger"
    v-if="isVisible"
  >
    <div class="the-container">
      <div class="the-grid">
        <div
          class="column"
          v-for="i in columnCount"
          :key="`grid-debugger-column-${i}`"
        >
          <div class="indexLabel">{{ i }}</div>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
const columnCount = ref(0)
const isVisible = ref(false)

const updateColumnCount = () => {
  if (!import.meta.client) return
  const cssCount = getComputedStyle(document.documentElement).getPropertyValue(
    "--grid-columns"
  )
  columnCount.value = parseInt(cssCount, 10)
}

const toggleGrid = () => {
  isVisible.value = !isVisible.value
  if (import.meta.client) {
    localStorage.setItem("gridDebug", isVisible.value ? "true" : "false")
  }
}

const onResize = (data) => {
  updateColumnCount()
}

useResize2(onResize)

const keys = useMagicKeys()
const ctrlG = keys["Ctrl+G"]

whenever(ctrlG, toggleGrid)

onMounted(() => {
  if (!import.meta.client) return
  onResize()

  if (localStorage.getItem("gridDebug") === "true") {
    isVisible.value = true
  }

  // document.addEventListener("keyup", (e) => {
  //   if (e.which === 71) {
  //     // G key
  //     toggleGrid()
  //   }
  // })
})
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.grid-debugger {
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100vw - var(--scrollbar-width));
  height: 100%;
  z-index: 1000;
  overflow: hidden;
  pointer-events: none;
}

.inner {
  @include fill;
}
.grid {
  @include gridMain();
  height: 100%;
}
.the-container,
.the-grid {
  height: 100%;
}
.column {
  position: relative;
  grid-column: auto / span 1;

  background: rgba(0, 0, 255, 0.05);
  border: 1px solid rgba(0, 0, 255, 0.5);
  border-top: 0;
  border-bottom: 0;

  &:nth-of-type(2n) {
    background: rgba(0, 255, 255, 0.05);
    border: 1px solid rgba(0, 255, 255, 0.5);
    border-top: 0;
    border-bottom: 0;
  }
  // @include breakpoint(tablet desktop) {
  //     &:nth-of-type(24),
  //     &:nth-of-type(25) {
  //         background: rgba(255, 0, 255, 0.15);
  //     }
  // }
  @include mobile {
    &:nth-of-type(8),
    &:nth-of-type(9) {
      background: rgba(255, 0, 255, 0.15);
    }
  }
}
.indexLabel {
  position: absolute;
  font-size: 1rem;
  top: 0.5rem;
  left: 10%;
  color: rgba(0, 0, 255, 1);
}
// .toggle
//   pointer-events: auto

//   position: fixed
//   right: 0
//   bottom: 0

//   +flex-center
//   width: 24px
//   height: 24px

//   background: blue

//   span
//     display: block
//     width: 1px
//     height: 14px
//     margin: 5px 0.5px

//     background: cyan

//   &.is-visible
//     background: cyan

//     span
//       background: blue

.vertical {
  position: absolute;
  left: 0;
  top: 50%;

  width: 100%;
  height: 1px;

  background: red;
  border: 0;
}
</style>
